import { render, staticRenderFns } from "./KoioteSilo1.vue?vue&type=template&id=189d63f4&scoped=true&"
import script from "./KoioteSilo1.vue?vue&type=script&lang=js&"
export * from "./KoioteSilo1.vue?vue&type=script&lang=js&"
import style0 from "./KoioteSilo1.vue?vue&type=style&index=0&id=189d63f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d63f4",
  null
  
)

export default component.exports